<template>
  <div class="wrap">
    <!-- <div @click="changeOn" :class="isOff?'isOff':'isOn'"> -->
    <audio id="audio" :src="require('../../assets/bgm.mp3')" loop="loop"></audio>
    <Index v-if="!show" @bindStart="openPage" :showLoading="showLoading"/>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
    >
      <Game v-if="show=='game'" @back="onBack" />
      <Prize v-if="show=='prize'" @back="onBack" />
      <Live v-if="show=='live'" @back="onBack" />
    </transition>
  </div>
</template>

<script>
import Index from "./components/Index";
import Game from "./components/Game";
import Prize from "./components/Prize";
import Live from "./components/Live";
import wxApi from '@/util/wxapi';
import { getShare } from "@/api/index";
export default {
  data() {
    return {
      showLoading: true,
      isOff: true,
      show: '',
      // show: 'game'
    };
  },
  components: {
    Index,
    Game,
    Prize,
    Live
  },
  created() {
    let url = location.href.split('#')[0];
    console.log(url);
    getShare({ url }).then((res) => {
      let data = res.data
      // let link = location.href.split('?')[0];
      let link = 'https://mmk.wepie.cc/minions/';
      let option = {
        title: '测测你的不乖因子',
        link: link,
        imgUrl: link+'share.png',
        desc: '这里有一份属于你的不乖奖赏',
        success: this.test
      }
      wxApi.wxRegister(data, option);
    })
  },
  mounted() {
    // 自动播放音乐效果，解决微信自动播放问题
    document.addEventListener('touchstart',this.audioAutoPlay,false);
    document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
    let oAudio = document.querySelector("#audio");
    //播放完毕，重新循环播放
    oAudio.onended = function () {
      // oAudio.load();
      // oAudio.play();
    }
  },
  methods: {
    changeOn() {
      let oAudio = document.querySelector("#audio");
      if (this.isOff) {
        oAudio.play();//让音频文件开始播放     
      } else {
        oAudio.pause();//让音频文件暂停播放 
      }
      this.isOff = !this.isOff;
    },
    audioAutoPlay() {
      let audio = document.getElementById('audio');
      this.isOff = false;
      audio.play();
      document.removeEventListener('touchstart',this.audioAutoPlay);
    },
    // 返回首页
    onBack() {
      this.show = '';
      this.showLoading = false;
    },
    openPage(page) {
      console.log(page);
      this.show = page;
    },
    test() {
      console.log('普通分享');
    }
  },
};
</script>

<style scoped lang="less">
.wrap {
  height: 100vh;
  background: #0a0a0a;
}
</style>
